import(/* webpackMode: "eager" */ "/app/src/app/solutions/interceptiQ/page.tsx");
